import MastheadBanner from "@/components/golf/MastheadBanner";
import { useSiteContent } from "./useSiteContent";

/** Shared hero carousel used by both GolfGetaways.jsx and
 * ExquraExperience.jsx — one siteContent doc, edited once under Edit
 * Site's "Getaways & Experience Banner" entry, shown on both pages. Same
 * self-fetching pattern as SiteFooter. About Courses passes its own
 * pageKey ("About Courses Banner" in Edit Site). */
export default function SiteMasthead({ pageKey = "golf-getaways-masthead" }) {
  const { blocks, ready } = useSiteContent(pageKey);
  // Same height as MastheadBanner, so nothing jumps when it swaps in — and
  // its built-in default slides never flash before the published ones.
  if (!ready) {
    return (
      <div
        className="w-full bg-[#0B2421]"
        style={{ height: "clamp(340px, 52vw, 540px)" }}
      />
    );
  }
  return <MastheadBanner fields={blocks[0]?.fields} />;
}
